import { useEffect, useMemo } from 'react';
import { useCounter } from './useCounter';
import { formatTimerDate, getDateDifferenceFromCurrentDate } from './helpers';
export const useFormatTime = (formatDaysToString, date, onTimeOut, hideHours) => {
    const days = useMemo(() => getDateDifferenceFromCurrentDate('days', date), [date]);
    const defaultCountDown = useMemo(() => getDateDifferenceFromCurrentDate('seconds', date), [date]);
    const { countDown, counterInterval, clearCurrentInterval } = useCounter(defaultCountDown, onTimeOut);
    useEffect(() => {
        counterInterval();
    }, [counterInterval]);
    useEffect(() => {
        if (days > 0)
            clearCurrentInterval();
    }, [clearCurrentInterval, days]);
    const formattedString = formatTimerDate(countDown, date, formatDaysToString, hideHours);
    return {
        ...formattedString,
        countDown,
        days,
    };
};
//# sourceMappingURL=useFormatTime.js.map